import { getAppConfig } from '@/api/modules/user';
import { makeAutoObservable } from 'mobx';
import { makePersistable, isHydrated } from 'mobx-persist-store';
import toutiaoIcon from '@/assets/platforms/toutiao.png';
import baiduIcon from '@/assets/platforms/baidu.png';
import sohuIcon from '@/assets/platforms/sohu.png';
import zhihuIcon from '@/assets/platforms/zhihu.png';
import xhsIcon from '@/assets/platforms/xhs.png';
import neteaseIcon from '@/assets/platforms/netease.png';
import qqIcon from '@/assets/platforms/qq.png';
import bilibiliIcon from '@/assets/platforms/bilibili.png';
import weixinIcon from '@/assets/platforms/wx.png';
import zdmIcon from '@/assets/platforms/zdm.png';
import douyinIcon from '@/assets/platforms/douyin.png';
import { getMaxAuthNum, getPlatformAuthNum } from '@/api/modules/app';
import loginStore from '@/mobx/modules/login';

export interface IConfig {
  web: Record<string, any>;
  matrix_web: Record<string, any>;
  admin: Record<string, any>;
}

export interface IAppStore {
  isInFrame: boolean;
  config: IConfig;
  isOdm: boolean;
  platformId: number;
  // createUserName: string;
}

class AppStore {
  // isInFrame = window.self !== window.top;
  config = JSON.parse(localStorage.getItem('AppStore') ?? '{}');
  // isOdm = +process.env.REACT_APP_AID !== 0;
  isOdm = false;
  platformId = 1;
  platformAuthNumConfig = [];
  maxAuthNum = 0;

  constructor() {
    // console.log(
    //   'process.env.REACT_APP_AID',
    //   +process.env.REACT_APP_AID !== 0,
    //   window.self !== window.top
    // );

    // this.isOdm = +process.env.REACT_APP_AID !== 0;
    this.isOdm = false;
    // this.isInFrame = window.self !== window.top;
    if (loginStore.token) {
      this.getPlatformConfig();
    }
    makeAutoObservable(this);
    makePersistable(this, {
      name: 'AppStore',
      properties: ['config', 'isInFrame'],
      storage: window.localStorage,
    });
  }

  get isHydrated() {
    return isHydrated(this);
  }

  get isZhaiXing() {
    return appStore.config?.web?.app.copyright_text?.includes('摘星') || false;
  }

  get isInFrame() {
    return window.self !== window.top;
  }

  get navList() {
    return [
      {
        name: '今日头条',
        key: 'jrtt',
        component: null,
        meta: {
          icon: toutiaoIcon,
          webviewUrl: 'https://mp.toutiao.com/auth/page/login',
          registerUrl: 'https://www.toutiao.com/about/',
          platform: 1,
          hidden: true,
          authNum:
            this.platformAuthNumConfig?.find((item) => item.id === 1)
              ?.auth_count || 0,
        },
      },
      {
        name: '百家号',
        key: 'bjh',
        component: null,
        meta: {
          icon: baiduIcon,
          webviewUrl: 'https://baijiahao.baidu.com/builder/theme/bjh/login',
          registerUrl:
            'https://passport.baidu.com/static/passpc-account/html/protocal.html',
          platform: 2,
          hidden: true,
          authNum:
            this.platformAuthNumConfig?.find((item) => item.id === 2)
              ?.auth_count || 0,
        },
      },
      {
        name: '搜狐号',
        key: 'sohu',
        component: null,
        meta: {
          icon: sohuIcon,
          platform: 4,
          webviewUrl: 'https://mp.sohu.com/mpfe/v4/login',
          registerUrl: 'https://mp.sohu.com/baike#/dashboard',
          hidden: true,
          authNum:
            this.platformAuthNumConfig?.find((item) => item.id === 4)
              ?.auth_count || 0,
        },
      },
      // {
      //   name: '知乎',
      //   key: 'zhihu',
      //   component: null,
      //   meta: {
      //     icon: zhihuIcon,
      //     platform: 6,
      //     hidden: true,
      //     webviewUrl: 'https://www.zhihu.com/',
      //     register: 'https://www.zhihu.com/term/zhihu-terms',
      //     authNum:
      //       this.platformAuthNumConfig?.find((item) => item.id === 6)
      //         ?.auth_count || 0,
      //   },
      // },
      {
        name: '小红书',
        key: 'xhs',
        component: null,
        meta: {
          icon: xhsIcon,
          webviewUrl: 'https://creator.xiaohongshu.com/',
          registerUrl:
            'https://creator.xiaohongshu.com/creator/encyclopedia?from_login=true',
          platform: 7,
          hidden: true,
          authNum:
            this.platformAuthNumConfig?.find((item) => item.id === 7)
              ?.auth_count || 0,
        },
      },
      {
        name: '网易号',
        key: 'netease',
        component: null,
        meta: {
          icon: neteaseIcon,
          webviewUrl: 'https://mp.163.com/',
          registerUrl: 'https://mp.163.com/college.html#/guidence/hot/account',

          platform: 8,
          hidden: true,
          authNum:
            this.platformAuthNumConfig?.find((item) => item.id === 8)
              ?.auth_count || 0,
        },
      },
      {
        name: '哔哩哔哩',
        key: 'bilibili',
        component: null,
        meta: {
          icon: bilibiliIcon,
          webviewUrl: 'https://member.bilibili.com/',
          registerUrl: 'https://www.bilibili.com/blackboard/privacy-pc.html',
          platform: 9,
          hidden: true,
          authNum:
            this.platformAuthNumConfig?.find((item) => item.id === 9)
              ?.auth_count || 0,
        },
      },
      {
        name: '企鹅号',
        key: 'qq',
        component: null,
        meta: {
          icon: qqIcon,
          webviewUrl: 'https://om.qq.com/',
          registerUrl: 'https://kf.om.qq.com/',
          platform: 10,
          hidden: true,
          authNum:
            this.platformAuthNumConfig?.find((item) => item.id === 10)
              ?.auth_count || 0,
        },
      },
      {
        name: '微信公众号',
        key: 'wx',
        component: null,
        meta: {
          icon: weixinIcon,
          webviewUrl: 'https://mp.weixin.qq.com/',
          registerUrl:
            'https://mp.weixin.qq.com/cgi-bin/announce?action=getannouncement&key=1503979103&version=1&lang=zh_CN&platform=2',
          platform: 3,
          hidden: true,
          authNum:
            this.platformAuthNumConfig?.find((item) => item.id === 3)
              ?.auth_count || 0,
        },
      },
      {
        name: '值得买',
        key: 'zdm',
        component: null,
        meta: {
          icon: zdmIcon,
          webviewUrl: 'https://www.smzdm.com/',
          registerUrl: 'https://www.zhidemai.com/policy',
          platform: 11,
          hidden: true,
          authNum:
            this.platformAuthNumConfig?.find((item) => item.id === 11)
              ?.auth_count || 0,
        },
      },
      {
        name: '抖音',
        key: 'douyin',
        component: null,
        meta: {
          icon: douyinIcon,
          webviewUrl: 'https://www.douyin.com/',
          registerUrl: 'https://www.douyin.com/',
          platform: 12,
          hidden: true,
          authNum:
            this.platformAuthNumConfig?.find((item) => item.id === 12)
              ?.auth_count || 0,
        },
      },
    ];
  }

  setPlatformId(id: number) {
    this.platformId = id;
  }

  async getPlatformConfig() {
    getPlatformAuthNum().then((res) => {
      this.platformAuthNumConfig = res.data?.platforms || [];
    });

    getMaxAuthNum().then((res) => {
      this.maxAuthNum = res.data?.max_auth_num || 0;
    });
  }

  async getConfig() {
    const { data } = await getAppConfig();
    const res = JSON.parse(data);
    this.config = res;
  }
}

const appStore = new AppStore();

export default appStore;
